// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/device/v2/device.v2.proto (package no.jotta.openapi.device.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { BackgroundJob } from "../../job/v1/job.v1_pb.js";
/**
 * @generated from enum no.jotta.openapi.device.v2.DeviceType
 */
export var DeviceType;
(function (DeviceType) {
    /**
     * @generated from enum value: UNKNOWN_DEVICE = 0;
     */
    DeviceType[DeviceType["UNKNOWN_DEVICE"] = 0] = "UNKNOWN_DEVICE";
    /**
     * a stationary PC.
     *
     * @generated from enum value: WORKSTATION = 1;
     */
    DeviceType[DeviceType["WORKSTATION"] = 1] = "WORKSTATION";
    /**
     * a portable PC.
     *
     * @generated from enum value: LAPTOP = 2;
     */
    DeviceType[DeviceType["LAPTOP"] = 2] = "LAPTOP";
    /**
     * a portable Mac.
     *
     * @generated from enum value: MACBOOK = 3;
     */
    DeviceType[DeviceType["MACBOOK"] = 3] = "MACBOOK";
    /**
     * a home Mac.
     *
     * @generated from enum value: IMAC = 4;
     */
    DeviceType[DeviceType["IMAC"] = 4] = "IMAC";
    /**
     * Mac Pro, a business Mac.
     *
     * @generated from enum value: MACPRO = 5;
     */
    DeviceType[DeviceType["MACPRO"] = 5] = "MACPRO";
    /**
     * a special Jotta device.
     *
     * @generated from enum value: JOTTA = 6;
     */
    DeviceType[DeviceType["JOTTA"] = 6] = "JOTTA";
    /**
     * a mobile device.
     *
     * @generated from enum value: IPHONE = 7;
     */
    DeviceType[DeviceType["IPHONE"] = 7] = "IPHONE";
    /**
     * iPad, a mobile device.
     *
     * @generated from enum value: IPAD = 8;
     */
    DeviceType[DeviceType["IPAD"] = 8] = "IPAD";
    /**
     *  a mobile device.
     *
     * @generated from enum value: ANDROID = 9;
     */
    DeviceType[DeviceType["ANDROID"] = 9] = "ANDROID";
    /**
     * Windows phone
     *
     * @generated from enum value: WINDOWS_PHONE = 10;
     */
    DeviceType[DeviceType["WINDOWS_PHONE"] = 10] = "WINDOWS_PHONE";
    /**
     * Windows tablet
     *
     * @generated from enum value: WINDOWS_TABLET = 11;
     */
    DeviceType[DeviceType["WINDOWS_TABLET"] = 11] = "WINDOWS_TABLET";
    /**
     * Linux command line cli
     *
     * @generated from enum value: CLI = 12;
     */
    DeviceType[DeviceType["CLI"] = 12] = "CLI";
    /**
     * Apple TV
     *
     * @generated from enum value: APPLE_TV = 13;
     */
    DeviceType[DeviceType["APPLE_TV"] = 13] = "APPLE_TV";
})(DeviceType || (DeviceType = {}));
// Retrieve enum metadata with: proto3.getEnumType(DeviceType)
proto3.util.setEnumType(DeviceType, "no.jotta.openapi.device.v2.DeviceType", [
    { no: 0, name: "UNKNOWN_DEVICE" },
    { no: 1, name: "WORKSTATION" },
    { no: 2, name: "LAPTOP" },
    { no: 3, name: "MACBOOK" },
    { no: 4, name: "IMAC" },
    { no: 5, name: "MACPRO" },
    { no: 6, name: "JOTTA" },
    { no: 7, name: "IPHONE" },
    { no: 8, name: "IPAD" },
    { no: 9, name: "ANDROID" },
    { no: 10, name: "WINDOWS_PHONE" },
    { no: 11, name: "WINDOWS_TABLET" },
    { no: 12, name: "CLI" },
    { no: 13, name: "APPLE_TV" },
]);
/**
 * @generated from message no.jotta.openapi.device.v2.Device
 */
export class Device extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * A client generated string that identifies a device, allowing a physical device to associate itself with the same
     * virtual device across reinstallation/upgrades
     *
     * @generated from field: string installation_id = 2;
     */
    installationId = "";
    /**
     * @generated from field: string display_name = 3;
     */
    displayName = "";
    /**
     * @generated from field: no.jotta.openapi.device.v2.DeviceType type = 4;
     */
    type = DeviceType.UNKNOWN_DEVICE;
    /**
     * path of the corresponding device in the file API
     *
     * @generated from field: string path = 5;
     */
    path = "";
    /**
     * @generated from field: string encoded_content_ref = 6;
     */
    encodedContentRef = "";
    /**
     * total storage size, in number of bytes
     *
     * @generated from field: int64 device_size = 7;
     */
    deviceSize = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.Device";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "installation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(DeviceType) },
        { no: 5, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "encoded_content_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "device_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new Device().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Device().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Device().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Device, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.GetRequest
 */
export class GetRequest extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.GetRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.GetResponse
 */
export class GetResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.device.v2.Device device = 1;
     */
    device;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.GetResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "device", kind: "message", T: Device },
    ]);
    static fromBinary(bytes, options) {
        return new GetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.MatchRequest
 */
export class MatchRequest extends Message {
    /**
     * @generated from field: string installation_id = 1;
     */
    installationId = "";
    /**
     * can be used to match name-based legacy installations, differs from display_name
     *
     * @generated from field: string name = 2;
     */
    name = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.MatchRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "installation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new MatchRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.MatchResponse
 */
export class MatchResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.device.v2.Device devices = 1;
     */
    devices = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.MatchResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "devices", kind: "message", T: Device, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new MatchResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.CreateRequest
 */
export class CreateRequest extends Message {
    /**
     * @generated from field: string installation_id = 1;
     */
    installationId = "";
    /**
     * @generated from field: string display_name = 2;
     */
    displayName = "";
    /**
     * @generated from field: no.jotta.openapi.device.v2.DeviceType type = 3;
     */
    type = DeviceType.UNKNOWN_DEVICE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.CreateRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "installation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(DeviceType) },
    ]);
    static fromBinary(bytes, options) {
        return new CreateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.CreateResponse
 */
export class CreateResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.device.v2.Device device = 1;
     */
    device;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.CreateResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "device", kind: "message", T: Device },
    ]);
    static fromBinary(bytes, options) {
        return new CreateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.ListRequest
 */
export class ListRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.ListRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ListRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.ListResponse
 */
export class ListResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.device.v2.Device devices = 1;
     */
    devices = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.ListResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "devices", kind: "message", T: Device, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ListResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.ModifyRequest
 */
export class ModifyRequest extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: string installation_id = 2;
     */
    installationId = "";
    /**
     * @generated from field: string display_name = 3;
     */
    displayName = "";
    /**
     * @generated from field: no.jotta.openapi.device.v2.DeviceType type = 4;
     */
    type = DeviceType.UNKNOWN_DEVICE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.ModifyRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "installation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "type", kind: "enum", T: proto3.getEnumType(DeviceType) },
    ]);
    static fromBinary(bytes, options) {
        return new ModifyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModifyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModifyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModifyRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.ModifyResponse
 */
export class ModifyResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.ModifyResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new ModifyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModifyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModifyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModifyResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.DeleteRequest
 */
export class DeleteRequest extends Message {
    /**
     * @generated from field: string id = 1;
     */
    id = "";
    /**
     * @generated from field: bool supports_background_jobs = 2;
     */
    supportsBackgroundJobs = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.DeleteRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "supports_background_jobs", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new DeleteRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.device.v2.DeleteResponse
 */
export class DeleteResponse extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.job.v1.BackgroundJob background_job = 1;
     */
    backgroundJob;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.device.v2.DeleteResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "background_job", kind: "message", T: BackgroundJob, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new DeleteResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteResponse, a, b);
    }
}
